import React from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPlayCircle,
	faBook,
	faLightbulb,
	faCommentDots,
	faBug
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../../../assets/css/components/StudentHomepage/StudentResourceMenu/StudentResourceMenu.css'
import { FeedbackLink } from '../../../../config'
library.add(faPlayCircle, faBook, faLightbulb, faCommentDots, faBug)

/*This component is responsible for the supporting resource menu that lives on the left side of the
	student dashboard. If a similar structure of resource menu is to be used else where (for other
	accounts) in the future, this component should be refactor to abstract the resource listed and
	change the classNames appropriately to be more dynamic*/
const StudentResourceMenu = ({ handleHideIntercom }) => {
	const resources = [
		{
			title: 'Video Tutorials',
			icon: faPlayCircle,
			link: 'https://www.youtube.com/playlist?list=PL84Pvj8x5B02gzVx9O-KzGcjnqCDUU0AZ'
		},
		{ title: 'Knowledge Base', icon: faBook, link: 'http://support.immersedgames.com/' },
		{ title: 'Give Feedback', icon: faLightbulb, link: FeedbackLink() }
	]

	return (
		<aside className='studentResourceMenu'>
			<h2 className='studentResourceMenu-title'> Resources </h2>
			<ul className='studentResourceMenu-list'>
				{resources.map((resourceItem, index) => {
					return (
						<li
							key={resourceItem.title + index}
							className='studentResourceMenu-listItem'>
							<a href={resourceItem.link} className='resourceLink' target='_blank'>
								<FontAwesomeIcon icon={resourceItem.icon} />
								<span>{resourceItem.title}</span>
							</a>
						</li>
					)
				})}
				<li key='Live Support' className='studentResourceMenu-listItem'>
					<button className='resourceLink' onClick={() => handleHideIntercom()}>
						<FontAwesomeIcon icon={faCommentDots} />
						<span>Live Support</span>
					</button>
				</li>
			</ul>
		</aside>
	)
}

export default StudentResourceMenu
